import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from '@mui/material'
import { DIALOGS } from '~/components/Charts/chrome/chartChrome'

interface Props {
  open: boolean
  collectionName: string
  pinCount?: number | null
  onClose: () => void
  onConfirm: () => void | Promise<void>
  isSubmitting?: boolean
  error?: string | null
}

function describePins(pinCount: number | null | undefined): string {
  return DIALOGS.pinsAlsoDeleted(pinCount)
}

export function CollectionDeleteConfirmDialog({
  open,
  collectionName,
  pinCount,
  onClose,
  onConfirm,
  isSubmitting = false,
  error = null,
}: Props) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{DIALOGS.deleteCollectionTitle}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ minWidth: 360 }}>
          <DialogContentText>
            {DIALOGS.deleteCollectionQuestion(collectionName)} {describePins(pinCount)}
          </DialogContentText>
          {error ? <Alert severity="error">{error}</Alert> : null}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{DIALOGS.cancel}</Button>
        <Button color="error" variant="contained" onClick={onConfirm} disabled={isSubmitting}>
          {DIALOGS.delete}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
